<script>
	const studentLibraryUtilities = require('utilities/studentLibraryUtilities');
	const getReadingList = studentLibraryUtilities.getReadingList;
	const removeReadingList = studentLibraryUtilities.removeReadingList;
	const analyticsUtilities = require('utilities/analyticsUtilities');
	const fireEvent = analyticsUtilities.fireEvent;
	const SL_BOOKMARK = analyticsUtilities.events.SL_BOOKMARK;

	module.exports = {
		components: {
			'library-product-card': require('components/library-product-card.vue').default,
			'load-mask': require('components/load-mask.vue').default
		},
		modelData: ['libraryReadingList'],
		data() {
			return {
				// filter: '',
				loading: false
			};
		},
		computed: {
			results() {
				let libraryReadingList = this.libraryReadingList;
				let list = [];

				if (libraryReadingList && libraryReadingList.length) {
					list = libraryReadingList;
				}

				return list;
			}
		},
		methods: {
			removeFromList(id) {
				fireEvent(SL_BOOKMARK, {
					pid: id,
					value: false,
					loc: 'read-next'
				});
				this.loading = true;
				removeReadingList(id).then(() => (this.loading = false));
			}
		},
		mounted() {
			this.loading = true;
			getReadingList().finally(() => (this.loading = false));
		}
	};
</script>
<style lang="scss">
	@import 'config/variables';
	@import 'config/colors';

	.library-read-next {
		position: relative;
		padding-top: 2rem;

		.library-read-next-header {
			text-align: right;

			.input-select {
				display: inline-block;
			}
		}

		.library-product-card {
			vertical-align: top;

			.remove-link {
				cursor: pointer;

				&:hover {
					color: $c-blue;
				}
			}
		}
	}
</style>
<template>
	<div class="library-read-next">
		<load-mask v-if="loading"></load-mask>
		<div class="library-read-next-inner wrapper">
			<!-- <div class="library-read-next-header">
				<div class="select-container form">
					<div class="input-select">
						<select v-model="filter">
							<option value=""
								selected>All Articles</option>
							<option value="my">My Articles</option>
							<option value="teacher">Teacher Recommendations</option>
						</select>
					</div>
				</div>
			</div> -->
			<library-product-card
				v-for="(item, index) in results"
				:key="item.id"
				:id="item.id"
				:img="item.img_highres2"
				:img-alt="item.imgAlt"
				:title="item.title"
				:topics="item.libraryTopics"
				:show-reading-list="false"
				:article-index="index"
				:level="((item.canonicalGrade && [item.canonicalGrade]) || item.grades) | getGradeRangeString">
				<span
					class="remove-link"
					@click="removeFromList(item.uuid)"
					>Remove</span
				>
			</library-product-card>
			<div
				v-if="!loading && results && results.length === 0"
				class="text-centered padding-top-large padding-bottom-large">
				<p>Items you've bookmarked to read next will appear here.</p>
			</div>
		</div>
	</div>
</template>
